<template>
  <div class="GroupManage">
    <van-nav-bar title="群成员管理" fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="manage">
      <van-checkbox class="all" v-model="checked" type="info" @click="toggleAll">全选</van-checkbox>
      <van-checkbox-group v-model="result" ref="checkboxGroup">
        <van-checkbox
          :name="item.u_id"
          v-for="(item,index) in groupmemberInfo"
          :key="index+'a'"
          v-if="item.u_id != u_id"
        >       
          <van-cell border
            :title="item.pivot.ug_group_nick?item.pivot.ug_group_nick:item.f_name.f_name?item.f_name.f_name:item.u_nickname?item.u_nickname:item.u_login_id"
          >
            <van-image
              slot="icon"
              class="err-image-header"
              round
              :src="attach_url+item.u_headportrait"
            />
          </van-cell>
        </van-checkbox>
      </van-checkbox-group>
      <van-cell-group>
        <van-button type="info" block @click="onClickMove" v-if="group_manage==0">移动</van-button>
        <van-button type="danger" block @click="onClickDelete">删除</van-button>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "GroupManage",
  data() {
    return {
      ug_id: "",
      groupmemberInfo: "",
      checked: false,
      result: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
       group_manage: localStorage.getItem("group_manage"),
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_id: this.ug_id,
        token: this.token,
        u_id: this.u_id,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Groups/getGroupUserInfoById" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.groupmemberInfo = response.data.result[0].group_user;
          }
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    // 修改按钮
    onClickRight() {
      // console.log(this.result);
    },
    // 全选
    toggleAll() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        this.$refs.checkboxGroup.toggleAll(true);
      }
    },
    // 移动群成员
    onClickMove() {
      //console.log(this.result)
      this.$router.push({
        name: "MoveGroupMember",
        query: {
          member_id: this.result,
          ug_id: this.ug_id
        }
      });
    },
    // 删除群成员
  onClickDelete() {
      this.$dialog
        .confirm({
          title: "删除群成员",
          message: "确定删除群成员吗？"
        })
        .then(() => {
          var params = {
            member_id: this.result,
            ug_id: this.ug_id,
            u_id: this.u_id,
            token: this.token,
            num:Math.random() 
          };
          var url = this.Conf.serverUrl + "Groups/deleteGroupMember"
          this.$axios
            .post(url, this.$qs.stringify(params))
            .then(response => {
              switch (response.data.code) {
                case 200:
                  this.$toast.success(response.data.msg);
                  this.loadData();
                  break;
                case 40001:
                  this.$toast.fail(response.data.msg);
                  break;
              }
              //console.log(this.groupmemberInfo);
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Group/GroupManage.vue